import React from 'react';
import style from './form.module.scss';
import classNames from 'classnames';

interface FormOwnProps {
    header: React.ReactNode;
    submit: () => void;
    formClassName?: string;
}

const FormHeader: React.FC<{}> = ({children}) => (
    <div className={style.Header}>{children}</div>
);

const Form: React.FC<FormOwnProps> = ({header, submit, children, formClassName}) => {
    const submitEventListener = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        submit();
    };

    return (
        <form
            className={classNames(style.Form, formClassName)}
            noValidate={true}
            onSubmit={submitEventListener}
        >
            <FormHeader>
                {header}
            </FormHeader>
            {children}
        </form>
    );
};

export { Form, FormHeader };
